import { Component, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs/Subscription'
import { FormControl } from '@angular/forms'
import { UserModel } from '../../models/user.model'
import { fuseAnimations } from '../../../core/animations'
import 'rxjs/add/operator/distinctUntilChanged'
import 'rxjs/add/operator/debounceTime'
import { UserService } from '../../services/user.service'
import { userDutch } from './i18n/nl'
import { userEnglish } from './i18n/en'
import { FuseTranslationLoaderService } from '../../../core/services/translation-loader.service'
import { ActivatedRoute, Router } from '@angular/router'

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
  animations: fuseAnimations,
})
export class UserComponent implements OnInit, OnDestroy {
  searchInput: FormControl
  currentUser: UserModel

  totalUsers: number

  constructor(
    private userService: UserService,
    private translationLoader: FuseTranslationLoaderService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.translationLoader.loadTranslations(userEnglish, userDutch)
  }

  ngOnInit() {}

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// ./src/app/main/content/users/user.component.ts